import { View } from 'react-native'

import { BestStreakMetricCard } from './BestStreakMetricCard'
import { CurrentStreakMetricCard } from './CurrentStreakMetricCard'
import { ExercisesThisWeekMetricCard } from './ExercisesThisWeekMetricCard'
import { ExerciseTimeMetricCard } from './ExerciseTimeMetricCard'
import { TotalExercisesMetricCard } from './TotalExercisesMetricCard'
import { WarmupsMetricCard } from './WarmupsMetricCard'

export { StatisticsCardsSkeleton } from './StatisticsCardsSkeleton'

export function StatisticsCards() {
  return (
    <View className="flex-row flex-wrap justify-between">
      <WarmupsMetricCard />
      <ExerciseTimeMetricCard />
      <ExercisesThisWeekMetricCard />
      <TotalExercisesMetricCard />
      <CurrentStreakMetricCard />
      <BestStreakMetricCard />
    </View>
  )
}
